import { Shield } from "lucide-react";
import { Link } from "react-router-dom";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="privacy-page">
      <nav className="glass-nav sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center h-16">
          <Link to="/" className="flex items-center gap-2">
            <Shield className="w-6 h-6 text-primary" />
            <span className="font-heading text-lg font-semibold tracking-tight">Spurwechsel</span>
          </Link>
        </div>
      </nav>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="font-heading text-3xl font-bold tracking-tight mb-8">Datenschutzerklärung</h1>
        <div className="prose prose-stone font-body text-sm leading-relaxed space-y-6">
          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">1. Verantwortlicher</h2>
            <p className="text-muted-foreground">Verantwortlich für die Datenverarbeitung auf dieser Website ist der Betreiber der Plattform Spurwechsel. Kontaktinformationen finden Sie im Impressum.</p>
          </section>
          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">2. Erhobene Daten</h2>
            <p className="text-muted-foreground">Wir erheben folgende personenbezogene Daten:</p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-1 mt-2">
              <li>Registrierungsdaten (Name, E-Mail-Adresse)</li>
              <li>Onboarding-Daten (MPU-Anlass, persönliche Situation)</li>
              <li>Trainingsdaten (Gesprächsverläufe, Analysen, Fortschrittsdaten)</li>
              <li>Zahlungsdaten (über Stripe verarbeitet, nicht bei uns gespeichert)</li>
              <li>Nutzungsdaten (Zugriffszeitpunkte, verwendete Funktionen)</li>
            </ul>
          </section>
          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">3. Zweck der Verarbeitung</h2>
            <p className="text-muted-foreground">Ihre Daten werden ausschließlich zum Zweck der Bereitstellung des MPU-Vorbereitungsdienstes, zur Personalisierung Ihres Trainings, zur Analyse und Verbesserung unseres Angebots sowie zur Abwicklung von Zahlungen verarbeitet.</p>
          </section>
          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">4. Rechtsgrundlage</h2>
            <p className="text-muted-foreground">Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. a (Einwilligung), lit. b (Vertragserfüllung) und lit. f (berechtigtes Interesse) DSGVO.</p>
          </section>
          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">5. Datenweitergabe</h2>
            <p className="text-muted-foreground">Ihre Daten werden nur an Dritte weitergegeben, soweit dies zur Vertragserfüllung erforderlich ist (z.B. Zahlungsabwicklung über Stripe) oder Sie eingewilligt haben. Eine Weitergabe an KI-Anbieter (OpenAI) erfolgt zur Durchführung der Gesprächssimulation in anonymisierter Form.</p>
          </section>
          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">6. Ihre Rechte</h2>
            <p className="text-muted-foreground">Sie haben das Recht auf:</p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-1 mt-2">
              <li>Auskunft über Ihre gespeicherten Daten</li>
              <li>Berichtigung unrichtiger Daten</li>
              <li>Löschung Ihrer Daten (Recht auf Vergessenwerden)</li>
              <li>Export Ihrer Daten in maschinenlesbarem Format</li>
              <li>Widerruf Ihrer Einwilligung</li>
              <li>Beschwerde bei einer Aufsichtsbehörde</li>
            </ul>
            <p className="text-muted-foreground mt-2">Sie können Ihre Daten jederzeit in Ihrem Profil exportieren oder löschen lassen.</p>
          </section>
          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">7. Datensicherheit</h2>
            <p className="text-muted-foreground">Wir verwenden verschlüsselte Verbindungen (HTTPS), sichere Passwort-Hashing-Verfahren und beschränken den Zugang zu Ihren Daten auf autorisierte Mitarbeiter. Zahlungsdaten werden ausschließlich von Stripe verarbeitet und nicht auf unseren Servern gespeichert.</p>
          </section>
          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">8. Speicherdauer</h2>
            <p className="text-muted-foreground">Ihre Daten werden solange gespeichert, wie Ihr Konto aktiv ist. Nach Kontolöschung werden alle personenbezogenen Daten unverzüglich gelöscht. Anonymisierte Nutzungsstatistiken können für interne Zwecke aufbewahrt werden.</p>
          </section>
          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">9. Wichtiger Hinweis</h2>
            <p className="text-muted-foreground">Spurwechsel ist ein Übungswerkzeug zur Vorbereitung auf das psychologische Gespräch der MPU. Es ersetzt keine professionelle MPU-Beratung, keine Therapie und keine Rechtsberatung. Die Nutzung garantiert nicht das Bestehen der MPU.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
